import * as React from 'react';
export const usdgSvg = React.forwardRef(function usdgSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#C7E36C',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.987 27.882c6.616 0 11.98-5.336 11.98-11.919 0-6.582-5.364-11.918-11.98-11.918-6.617 0-11.98 5.336-11.98 11.918 0 6.583 5.363 11.919 11.98 11.919Z',
      fill: '#314012',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M24.893 16.61c-.345 4.584-4.194 8.197-8.891 8.197-4.925 0-8.917-3.97-8.917-8.868s3.992-8.868 8.917-8.868c4.69 0 8.534 3.6 8.89 8.174h-4.264c.93-2.045.987-3.904-.03-4.753-1.503-1.255-4.78.167-7.317 3.176-2.539 3.008-3.378 6.464-1.875 7.718 1.503 1.254 4.779-.168 7.317-3.176.442-.525.833-1.063 1.169-1.6h5.001Z',
      fill: '#C7E36C',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M16.672 16.61h3.565l-1.377 1.793-2.188-.874v-.92Z',
      fill: '#C7E36C',
    }),
  );
});
usdgSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var usdg = {
  category: 'brand',
  colorable: false,
  name: 'usdg',
  svg: usdgSvg,
};
